import { BookSchema, SnakeToCamelCaseNested } from "@literati/kids-api";

/**
 * Given a starting number and an ending number, returns a mix
 * of the two values based on the percent provided.
 *
 * e.g.
 * - a `percent` value of 0 would return the value of `start`
 * - a `percent` value of 1.0 would return the value of `end`
 * - a `percent` value of 0.5 would return the value exactly between `start` and `end`
 */
export const interpolate = (start: number, end: number, percent: number) =>
  (end - start) * percent + start;

export const formatAuthorNames = (
  bookContributors: SnakeToCamelCaseNested<BookSchema>["contributors"]
): string | null =>
  bookContributors
    ? bookContributors
        .filter((contributor) => contributor?.isAuthor && contributor?.name)
        .map((author) => author.name)
        .join(", ")
    : null;
